\Jasiu\Documents\vigas\src\App.vue
<template>
  <div id="app" :class="{ 'home-page': isHomePage }">
    <!-- JSON-LD Structured Data for SEO -->
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "VI-GAS",
      "description": "Autoryzowany serwis urządzeń Viessmann - instalacja i naprawa kotłów gazowych, pomp ciepła i systemów grzewczych",
      "url": "https://www.vi-gas.pl",
      "telephone": "+48570422020",
      "email": "kontakt@vi-gas.pl",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "PL"
      },
      "priceRange": "$$",
      "image": "https://www.vi-gas.pl/logo.png",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "08:00",
          "closes": "17:00"
        }
      ],
      "sameAs": [],
      "areaServed": {
        "@type": "Country",
        "name": "Polska"
      },
      "brand": {
        "@type": "Brand",
        "name": "Viessmann"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Usługi serwisowe Viessmann",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Konserwacje gwarancyjne i pogwarancyjne",
              "description": "Serwis i naprawa kotłów przemysłowych o dużej mocy"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Diagnoza i naprawa",
              "description": "Profesjonalny serwis kotłów średniej mocy"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Instalacja systemów grzewczych",
              "description": "Montaż i uruchomienie kotłów Viessmann"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Automatyka i Smart Home",
              "description": "Instalacja systemów inteligentnego zarządzania ogrzewaniem"
            }
          }
        ]
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5",
        "reviewCount": "150"
      }
    }
    </script>
    
    <!-- Navigation -->
    <NavigationBar />
    
    <!-- Main Content - RouterView -->
    <router-view />
    
    <!-- Footer -->
    <AppFooter v-if="!isHomePage" />

    <!-- Cookies Consent -->
    <CookieConsentBanner />
  </div>
</template>

<script>
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import AOS from 'aos'
import 'aos/dist/aos.css'

import NavigationBar from './components/NavigationBar.vue'
import AppFooter from './components/AppFooter.vue'
import CookieConsentBanner from './components/CookieConsentBanner.vue'

export default {
  name: 'App',
  components: {
    NavigationBar,
    AppFooter,
    CookieConsentBanner
  },
  setup() {
    const route = useRoute()
    const isHomePage = computed(() => route.path === '/')

    onMounted(() => {
      AOS.init({
        duration: 1000,
        easing: 'ease-in-out',
        once: true
      })
    })

    return {
      isHomePage
    }
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  line-height: 1.6;
  color: #333;
  padding-top: 80px; // Add padding to account for fixed navbar
}

#app {
  min-height: 100vh;
}

// Global utility classes
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section {
  padding: 80px 0;
  
  // Ensure sections don't overlap with navbar
  &:first-of-type {
    padding-top: 100px;
  }
}

.btn {
  display: inline-block;
  padding: 12px 30px;
  background: linear-gradient(135deg, #FF6B35, #FF8E53);
  color: white;
  text-decoration: none;
  border-radius: 50px;
  font-weight: 600;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(255, 107, 53, 0.3);
  }
}

.btn-secondary {
  background: transparent;
  border: 2px solid #FF6B35;
  color: #FF6B35;
  
  &:hover {
    background: #FF6B35;
    color: white;
  }
}

// Smooth scrolling for anchor links with offset for fixed navbar
html {
  scroll-padding-top: 80px;
}

// Responsive design
@media (max-width: 768px) {
  body {
    padding-top: 70px; // Reduced for mobile
  }
  
  .container {
    padding: 0 15px;
  }
  
  .section {
    padding: 60px 0;
    
    &:first-of-type {
      padding-top: 80px;
    }
  }
  
  html {
    scroll-padding-top: 70px;
  }
}
</style>